import { createFileRoute } from '@tanstack/react-router';
import { useTranslations } from 'use-intl';
import { RouterLinkAs } from '@/lib/router-link';
import {
  Card,
  I,
  Icon,
  ListItem,
  List,
  PageHeader,
  Screen,
  ScreenBody,
  SettingIcon,
} from '@leanin/ui';
import { SETTINGS_HUB_ROWS } from '@/components/settings/catalog';
import { SettingsSearch } from '@/components/settings/SettingsSearch';
import { SignOutRow } from './-components/SignOutRow';

export const Route = createFileRoute('/_authed/settings/')({
  component: SettingsHubPage,
});

function SettingsHubPage() {
  const t = useTranslations('Settings');
  return (
    <Screen>
      <ScreenBody gap="2xl">
        <PageHeader title={t('hub.title')} />
        <SettingsSearch>
          <Card pad="flush">
            <List bordered={false}>
              {SETTINGS_HUB_ROWS.map((s) => (
                <ListItem
                  key={s.id}
                  linkAs={RouterLinkAs}
                  href={s.href}
                  leading={<SettingIcon tone={s.tone}>{I[s.icon]}</SettingIcon>}
                  title={t(s.titleKey)}
                  subtitle={t(s.descriptionKey)}
                  trailing={<Icon size={18}>{I.arrow}</Icon>}
                />
              ))}
            </List>
          </Card>

          <Card pad="flush">
            <List bordered={false}>
              <ListItem
                linkAs={RouterLinkAs}
                href="/help"
                leading={<SettingIcon tone="neutral">{I.globe}</SettingIcon>}
                title={t('hub.sections.help.label')}
                subtitle={t('hub.sections.help.description')}
                trailing={<Icon size={18}>{I.arrow}</Icon>}
              />
              <SignOutRow />
            </List>
          </Card>
        </SettingsSearch>
      </ScreenBody>
    </Screen>
  );
}
